<template>
  <div class="row center-block">
     <div class="col-md-12" >
       <div class="box">
         <div class="box-header col-md-12">
           <h3>Importar programação em csv</h3>
         </div>
         <!-- /.box-header -->
         <div class="box-body" :key="componentKey">
           <text-reader @load="enviarTexto($event)"></text-reader>
           <div class="row">
              <div class="col-sm-12 table-responsive">
                <paginate name="dados" :list="programacao" :per="5" class="paginate-list">
                  <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th>#</th>
                      <th>Empresa</th>
                      <th>Ordem</th>
                      <th>Ítem</th>
                      <th>Sequência</th>
                      <th>Máquina</th>
                      <th>Tempo Previsto</th>
                      <th>Quantidade</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr class="even" role="row" v-for="(detalhe, index) in paginated('dados')" :key="detalhe.id">
                        <td>{{index + 1}}</td>
                        <td>{{detalhe.empresa}}</td>
                        <td>{{detalhe.ordem}}</td>
                        <td>{{detalhe.item}}</td>
                        <td>{{detalhe.sequencia}}</td>
                        <td>{{detalhe.maquina}}</td>
                        <td>{{detalhe.tempo_previsto}}</td>
                        <td>{{detalhe.quantidade}}</td>
                      </tr>
                    </tbody>
                  </table>
                </paginate>
              </div>
            </div>
          <div class="row">
            <div class="col-sm-12 table-responsive">
              <paginate-links for="dados" :limit="5" :show-step-links="true" id="paginacao"></paginate-links>
            </div>
          </div>
        </div>
         <div class="box-footer">
           <template v-if="text !== ''">
             <div class="col-sm-2">
              <button type="button" v-on:click="limparFiles" class="btn btn-primary">
                Cancelar
              </button>
            </div>
            <div class="col-sm-2">
              <button type="button" v-on:click="text = ''" class="btn btn-success">
                Importar
              </button>
            </div>
           </template>
         </div>
         <!-- /.box-body -->
       </div>
     </div>
   </div> 
    <!-- Styled -->
</template>

<script>
  import TextReader from '../widgets/TextReader'

  export default {
    data() {
      return {
        componentKey: 0,
        text: '',
        programacao: [],
        paginate: ['dados']
      }
    },
    methods: {
      enviarTexto: function (event) {
        let lines = event.split('\r\n')
        let result = []
        let headers = lines[0].split(';')
        let qtdCabecalho = headers.length
        for (var i = 1; i < lines.length; i++) {
          var obj = { }
          var currentline = lines[i].split(';')
          for (var j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j]
          }
          if (currentline.length === qtdCabecalho) {
            result.push(obj)
          }
        }
        this.text = JSON.stringify(result)
        this.programacao = JSON.parse(this.text)
      },
      forceRender: function () {
        this.componentKey += 1
      },
      limparFiles() {
        this.text = ''
        this.programacao = []
        this.forceRender()
      }
    },
    mounted() {
      this.file1 = null
    },
    components: {
      TextReader
    }
  }
</script>



// WEBPACK FOOTER //
// ImportarProgramacao.vue?6abfa350